import React from 'react';
import { Menu, Search } from 'lucide-react';
import { NotificationBell } from './NotificationBell';
import { UserProfileMenu } from './UserProfileMenu';
import { Input } from '../ui/Input';

interface HeaderProps {
  onToggleNav: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onToggleNav }) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 60,
    padding: '0 20px',
    backgroundColor: 'var(--color-white)',
    borderBottom: '1px solid var(--color-light-grey)',
    gap: '20px',
    boxSizing: 'border-box',
  };

  const leftSectionStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  };

  const menuButtonStyle: React.CSSProperties = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-dark-grey)',
    transition: 'color 0.2s ease-in-out',
  };

  const logoStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    height: 36,
  };

  const logoImgStyle: React.CSSProperties = {
    height: '100%',
    width: 'auto',
    display: 'block',
  };

  const centreStyle: React.CSSProperties = {
    flex: 1,
    maxWidth: 400,
    display: 'flex',
    alignItems: 'center',
  };

  const searchContainerStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
  };

  const searchInputWrapperStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  };

  const rightSectionStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  };

  return (
    <header style={containerStyle}>
      <div style={leftSectionStyle}>
        <button
          style={menuButtonStyle}
          onClick={onToggleNav}
          aria-label="Toggle navigation"
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLElement).style.color = 'var(--color-magenta)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.color = 'var(--color-dark-grey)';
          }}
        >
          <Menu size={24} />
        </button>
        <div style={logoStyle}>
          <img src="/logo-landscape.svg" alt="The Lab" style={logoImgStyle} />
        </div>
      </div>

      <div style={centreStyle}>
        <div style={searchContainerStyle}>
          <div style={searchInputWrapperStyle}>
            <Search
              size={18}
              style={{
                position: 'absolute',
                left: '12px',
                color: 'var(--color-dark-grey)',
                pointerEvents: 'none',
              }}
            />
            <input
              type="text"
              placeholder="Search users, companies, projects..."
              style={{
                width: '100%',
                padding: '8px 12px 8px 36px',
                fontSize: '14px',
                fontFamily: 'var(--font-family)',
                border: '1px solid var(--color-light-grey)',
                borderRadius: '4px',
                outline: 'none',
                transition: 'all 0.2s ease-in-out',
              }}
              onFocus={(e) => {
                e.currentTarget.style.outline = '2px solid var(--color-magenta)';
              }}
              onBlur={(e) => {
                e.currentTarget.style.outline = 'none';
              }}
            />
          </div>
        </div>
      </div>

      <div style={rightSectionStyle}>
        <NotificationBell />
        <UserProfileMenu />
      </div>
    </header>
  );
};
